var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#AEBECA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19.64 12.97c.042-.32.073-.64.073-.97 0-.33-.031-.66-.072-1l2.169-1.63c.195-.15.247-.42.123-.64l-2.056-3.46c-.123-.22-.4-.31-.627-.22l-2.56 1c-.534-.39-1.09-.73-1.737-.98l-.38-2.65c-.042-.24-.258-.42-.515-.42H9.946c-.257 0-.473.18-.514.42l-.38 2.65c-.648.25-1.203.59-1.738.98l-2.56-1c-.226-.09-.503 0-.627.22L2.071 8.73c-.133.22-.072.49.124.64L4.364 11c-.041.34-.072.67-.072 1 0 .33.03.65.072.97l-2.17 1.66c-.195.15-.256.42-.123.64l2.056 3.46c.124.22.401.3.628.22l2.56-1.01c.534.4 1.09.74 1.737.99l.38 2.65c.041.24.257.42.514.42h4.112c.257 0 .473-.18.514-.42l.38-2.65c.649-.26 1.204-.59 1.738-.99l2.56 1.01c.226.08.504 0 .627-.22l2.056-3.46c.124-.22.072-.49-.123-.64l-2.17-1.66z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#AEBECA",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12 14c-1.105 0-2-.895-2-2s.895-2 2-2 2 .895 2 2-.895 2-2 2z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.40e252d9.svg";
export { ForwardRef as ReactComponent };